"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCardInfo = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _cardValidator = _interopRequireDefault(require("card-validator"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _CreditCardField = _interopRequireDefault(require("./CreditCardField.proptypes"));
var _constants = require("./constants");
var _utils = require("./utils");
var _excluded = ["accessible", "theme", "customProperties", "creditCardPatterns", "disabled", "translation", "countryCode", "label", "value", "cardType", "onFocus", "onChange", "onBlur", "showCardIcon", "onCardInfoChange"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// Register BigPay configuration
_cardValidator.default.creditCardType.addCard({
  niceType: 'BigPay',
  type: 'big-pay',
  patterns: [559998],
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: 'CVV',
    size: 3
  }
});
var getCardInfo = function getCardInfo(creditCardNumber) {
  var cardInfo = _cardValidator.default.number(creditCardNumber);
  if (!cardInfo || !cardInfo.card) {
    return null;
  }
  return cardInfo.card;
};
exports.getCardInfo = getCardInfo;
var getCardLogo = function getCardLogo(cardTypeInfo) {
  if (!cardTypeInfo) {
    return _constants.CARD_LOGO.empty;
  }
  if (!cardTypeInfo || !cardTypeInfo.type) {
    return _constants.CARD_LOGO.empty;
  }
  return _constants.CARD_LOGO[cardTypeInfo.type];
};
var CreditCardField = function CreditCardField(_ref) {
  var accessible = _ref.accessible,
    theme = _ref.theme,
    customProperties = _ref.customProperties,
    creditCardPatterns = _ref.creditCardPatterns,
    disabled = _ref.disabled,
    translation = _ref.translation,
    countryCode = _ref.countryCode,
    label = _ref.label,
    value = _ref.value,
    cardType = _ref.cardType,
    onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    showCardIcon = _ref.showCardIcon,
    onCardInfoChange = _ref.onCardInfoChange,
    restTextFieldProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    creditCardValue = _useState2[0],
    setCreditCardValue = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    cardLogo = _useState4[0],
    setCardLogo = _useState4[1];
  (0, _react.useEffect)(function () {
    if (value && value !== '' && value.length >= 6) {
      var cardValue = (0, _utils.getCurrentValue)(value);
      var creditCardBinRange = cardValue.substring(0, 6);
      var cardTypeInfo = getCardInfo(creditCardBinRange);
      setCardLogo(getCardLogo(cardTypeInfo));
      if (onCardInfoChange) onCardInfoChange(cardTypeInfo);
      cardValue = (0, _utils.seperateCreditCard)(cardValue, cardTypeInfo);
      setCreditCardValue(cardValue);
    } else if (onCardInfoChange) onCardInfoChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  var changeHandler = function changeHandler(event) {
    var inputValue = event.target.value;
    var cardValue = (0, _utils.getCurrentValue)(inputValue);
    var lastInputValue = (0, _utils.getLastInputedChar)(cardValue);

    // Only allow input that follows the CARD_INPUT_PATTERN regex
    if (inputValue && inputValue !== '' && !_constants.CARD_INPUT_PATTERN.test(lastInputValue)) {
      return;
    }
    var cardTypeInfo = getCardInfo(cardValue);
    setCardLogo(getCardLogo(cardTypeInfo));
    cardValue = (0, _utils.seperateCreditCard)(cardValue, cardTypeInfo);
    setCreditCardValue(cardValue);
    onChange(cardValue);
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({
    accessible: accessible,
    theme: theme,
    customProperties: _objectSpread(_objectSpread({}, customProperties), {}, {
      onChange: changeHandler
    }),
    label: label,
    value: creditCardValue,
    onFocus: onFocus,
    onChange: changeHandler,
    onBlur: onBlur,
    disabled: disabled,
    icon: showCardIcon && cardLogo
  }, restTextFieldProps)));
};
CreditCardField.propTypes = _CreditCardField.default.PropTypes;
CreditCardField.defaultProps = _CreditCardField.default.DefaultProps;
var _default = CreditCardField;
exports.default = _default;